module.exports = __webpack_public_path__ + "static/Red_Flag_Logo_4c_TM-e7a77c2ea12b5d4453fcc956938a234f.png";